import React, { Fragment } from 'react';
import { Dialog, DialogPanel, DialogTitle, Transition, TransitionChild } from '@headlessui/react';
import { AiFillCloseCircle } from 'react-icons/ai';

const Modal = ({ isOpen, isClose, children, title, options }) => {
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as='div' className='relative z-50' open={isOpen} onClose={isClose}>
          <TransitionChild
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <div className='fixed inset-0 bg-black bg-opacity-75' />
          </TransitionChild>

          <div className='fixed inset-0 overflow-y-auto'>
            <div className='flex min-h-full items-center justify-center p-4 text-center'>
              <TransitionChild
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0 scale-95'
                enterTo='opacity-100 scale-100'
                leave='ease-out duration-300'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-95'
              >
                <DialogPanel className='relative flex max-h-[90dvh] w-full max-w-lg flex-col overflow-hidden rounded-2xl border bg-white text-left shadow-xl transition-all'>
                  <div className='flex w-full shrink-0 items-center justify-between border-b p-3'>
                    {options ? (
                      <>{options}</>
                    ) : (
                      <DialogTitle as='h2' className='text-base/7 font-medium'>
                        {title || ''}
                      </DialogTitle>
                    )}

                    <button type='button' className='shrink-0 rounded-full bg-primary-blue-100' onClick={isClose}>
                      <AiFillCloseCircle className='h-[20px] w-[20px]' />
                    </button>
                  </div>

                  <div className='flex min-h-0 flex-1 flex-col overflow-y-auto p-2'>
                    {children}
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default Modal;